import { FC, useContext, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { InputText } from "primereact/inputtext";
import { FcCancel } from 'react-icons/fc'
import { TfiSave } from 'react-icons/tfi'
import { HiOutlineIdentification } from "react-icons/hi2";
import { changeScenarioName, setReferenceSimulation } from "../../../services/scenario-service";
import { error, success } from "../../../utils/notifications";
import { catchResponse } from "../../../utils/helperFunctions";
import { UserContext } from "../../../Redux/UserContext";
import { FiCommand } from "react-icons/fi";
import { VISUALIZACION_PERMISSIONS } from "../../../data/constants";
import { FaStar } from "react-icons/fa";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";

export const ChangeReferenceSimulationModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, scenarioId,referenceSimulationID, simulatedScenarios } = props

    const [state] = useContext(UserContext)

    const [loadingChangeReferenceSimulation, setLoadingchangeReferenceSimulation] = useState<boolean>(false)

    const [selectedReferenceSimulation, setSelectedReferenceSimulation] = useState<any>()

    const history:any = useHistory()

    const handleUpdateReferenceSimulation = async() => {
        try {
            setLoadingchangeReferenceSimulation(true)
            let body:any = {
                id_simulation: selectedReferenceSimulation.code
            }
            const res = await setReferenceSimulation(scenarioId,body)
            if(res.status === 200) {
                const { message, code, data } = res.data
                if(code === 200) {
                    success(message)
                    setVisible(false)
                    setLoadingchangeReferenceSimulation(false)
                    history.push(`/operative_scenario/${data}`)
                } else {
                    setLoadingchangeReferenceSimulation(false)
                    error(message)
                }
                setLoadingchangeReferenceSimulation(false)
            }
        } catch(err:any) {
            setLoadingchangeReferenceSimulation(false)
            catchResponse(err)
        }
    }

    const handleCloseReferenceSimulationModal = () => {
        setVisible(false)
        setSelectedReferenceSimulation(undefined)
    }


    const headerContent = (
        <div className="changename-header">
            <span>Cambiar simulación referencia</span>
        </div>
    )

    const footerContent = (
        <div className="changename-footer">
            <Button severity={'danger'} label="Cancelar" icon={<FcCancel style={{fontSize:20}} />} onClick={handleCloseReferenceSimulationModal}  outlined />
            <Button severity={'success'} label="Guardar" icon={loadingChangeReferenceSimulation? <FiCommand className="loading-icon" style={{fontSize:20}} /> :<TfiSave style={{fontSize:20}} />} disabled={state?.rol_id !== undefined? !VISUALIZACION_PERMISSIONS.U.includes(state?.rol_id) || loadingChangeReferenceSimulation || selectedReferenceSimulation === undefined : false} onClick={handleUpdateReferenceSimulation}  outlined />
        </div>
    );

    const handleChangeReferenceSimulation = (e:any) => {
        setSelectedReferenceSimulation(e.value)
    }

    return (
        <div className="card flex justify-content-center">
            <Dialog header={headerContent} visible={visible} style={{ width: '50vw' }} onHide={handleCloseReferenceSimulationModal} footer={footerContent}>
                <div className="changename-modal-container">

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="pajera">Simulación referencia actual</label>
                        <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon">
                                <AiOutlineStar style={{fontSize:20}} />
                            </span>
                            <InputText value={simulatedScenarios?.find((ss:any) => ss.id_scenario === referenceSimulationID)?.name_scenario} disabled />
                        </div>    
                    </div>

                    <div className="card flex justify-content-center">
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor="transporte">Nueva simulación referencia</label>
                        <div className="p-inputgroup flex-1">
                            <span className="p-inputgroup-addon">
                                <AiFillStar style={{fontSize:20}} />
                            </span>
                            <Dropdown value={selectedReferenceSimulation} onChange={handleChangeReferenceSimulation} options={simulatedScenarios?.map((ss:any) => ({name:ss.name_scenario,code:ss.id_scenario}))} optionLabel="name" 
                placeholder="Selecciona una simulación de referencia" className="w-full md:w-14rem" />
                        </div>     
                    </div>

                </div>
            </Dialog>
        </div>
    )
}